class CustomerAccountPrompt extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.checkCookie('account_prompt_notification_seen')
  }

  setupListeners () {
    super.setupListeners()

    this.els.trigger.element.addEventListener('mouseenter', () => this.hidePromptDot())
  }

  hidePromptDot () {
    // Hide the prompt dot by setting aria-hidden to true
    setTimeout(() => {
      this.els.dot.element.setAttribute('aria-hidden', 'true')
    }, 500)

    // Remove the event listener
    this.els.trigger.element.removeEventListener('mouseenter', () => this.hidePromptDot())

    // Hide dot for 60 days
    this.setCookie('account_prompt_notification_seen', 'true', 60)
  }

  setCookie (name, value, days) {
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = `; expires=${date.toUTCString()}`
    }
    document.cookie = `${name}=${value}${expires}; path=/`
  }

  getCookie (name) {
    const nameEQ = `${name}=`
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length)
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length)
      }
    }
    return null
  }

  checkCookie (name) {
    if (this.getCookie(name) === 'true') {
      this.hidePromptDot()
    } else {
      this.els.dot.element.setAttribute('aria-hidden', 'false')
    }
  }
}

if (!customElements.get('customer-account-prompt')) {
  customElements.define('customer-account-prompt', CustomerAccountPrompt)
}
